import React from "react"
import { AITrainingInstance } from "../../../../../../../../Models/API/AIModel"
import { TableColumn } from "resha"
import { fromNow } from "../../../../../../../../Helpers/Functions/dateFormat"
import { AITrainingStatus } from "./AITrainingStatus"
import { staticEvent } from "../../../../../../../../Helpers/Functions/event"
import { OutlinedButton } from "dash-styled"

export function getTrainingColumnDefinitions(
    modelInUseMap: Map<string, true>,
    onClick: (modelID: string) => void,
    onClickMetric: (datasetID: string) => void
): TableColumn<AITrainingInstance>[] {
    const columns: TableColumn<AITrainingInstance>[] = [
        {
            headerClassName: "w-1/4",
            renderHeader: () => "Source version",
            render: ({ model }) => {
                if (!model) {
                    return null
                }
                const isModelInUse = modelInUseMap.has(model.id)
                return (
                    <span
                        className={`text-smoke-610 ${
                            isModelInUse
                                ? "hover:text-rhino-800 hover:font-semibold"
                                : ""
                        }`}
                        onClick={
                            isModelInUse
                                ? staticEvent(() => onClick(model.id))
                                : undefined
                        }
                    >
                        version {model.version}
                    </span>
                )
            }
        },
        {
            className: "text-smoke-610",
            renderHeader: () => "Output version",
            render: ({ output_model }) => {
                const isModelInUse = modelInUseMap.has(output_model?.id ?? "")
                return (
                    <span
                        className={`text-smoke-610 ${
                            isModelInUse
                                ? "hover:text-rhino-800 hover:font-semibold"
                                : ""
                        }`}
                        onClick={
                            isModelInUse && output_model?.id !== undefined
                                ? staticEvent(() => onClick(output_model?.id))
                                : undefined
                        }
                    >
                        {output_model === undefined || output_model === null
                            ? "-"
                            : `version ${output_model.version}`}
                    </span>
                )
            }
        },
        {
            className: "text-smoke-810",
            renderHeader: () => "Last modified",
            render: ({ updated_at }) => {
                return updated_at ? fromNow(updated_at) : "na"
            }
        },
        {
            className: "text-smoke-810",
            renderHeader: () => "Ground truth",
            render: ({ dataset }) => {
                return (dataset?.metadata as any)?.["count"] ?? "-"
            }
        },
        {
            className: "text-smoke-810",
            renderHeader: () => "Status",
            render: trainingInstance => {
                return trainingInstance ? (
                    <AITrainingStatus
                        trainingInstanceState={trainingInstance.state}
                    />
                ) : (
                    "na"
                )
            }
        },
        {
            renderHeader: () => "Metrics",
            render: trainingInstance => {
                const datasetID = trainingInstance.dataset_id
                return trainingInstance && datasetID ? (
                    <OutlinedButton
                        label="View Metrics"
                        onClick={() => onClickMetric(datasetID)}
                    />
                ) : null
            }
        }
    ]

    return columns
}
